/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Sign_Password_RequiredInputs */

const en_common_sign_password_required = /** @type {(inputs: Common_Sign_Password_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter your password`)
};

const zh_common_sign_password_required = /** @type {(inputs: Common_Sign_Password_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请输入密码`)
};

/**
* | output |
* | --- |
* | "Enter your password" |
*
* @param {Common_Sign_Password_RequiredInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_sign_password_required = /** @type {((inputs?: Common_Sign_Password_RequiredInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Sign_Password_RequiredInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_sign_password_required(inputs)
	return zh_common_sign_password_required(inputs)
});
export { common_sign_password_required as "common.sign.password_required" }